class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    clearTimeout(this.openTimer);
    this.openTimer = setTimeout(() => {
      this.classList.add('animate', 'active');
      window.requestAnimationFrame(() => {
        if (!this.classList.contains('active')) return;
        const container = this.querySelector('.drawer__inner') || this.querySelector('#CartDrawer');
        if (container) trapFocus(container, this.querySelector('.drawer__inner') || this.querySelector('.drawer__close'));
      });
    });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    clearTimeout(this.openTimer);
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  async refreshContents({ open = true } = {}) {
    const ids = this.getSectionsToRender().map(section => section.id).join(',');
    const request = window.LuveonCartOperations ? window.LuveonCartOperations.request.bind(window.LuveonCartOperations) : fetch;
    const response = await request(`${window.routes.cart_url}?sections=${ids}`, { headers: { Accept: 'application/json' } });
    const sections = await response.json();
    if (!response.ok || !sections?.['cart-drawer']) throw new Error('Impossible d’actualiser le panier.');
    this.renderContents({ sections }, { open });
    return { sections };
  }

  renderContents(parsedState, { open = true } = {}) {
    if (!parsedState?.sections?.['cart-drawer']) throw new Error('La section panier est indisponible.');
    const drawerHTML = this.getSectionInnerHTML(parsedState.sections['cart-drawer'], '#CartDrawer');
    if (drawerHTML === null) throw new Error('La section panier est illisible.');
    this.querySelector('.drawer__inner')?.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement || !parsedState.sections?.[section.id]) return;
      const content = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (content !== null) sectionElement.innerHTML = content;
    });

    this.classList.toggle('is-empty', Boolean(this.querySelector('.lma-cart-empty')));

    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    if (open) this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML ?? null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
